<template>
  <div class="home-warpper">
    <div class="home-box">
      <h1>请选择需要登录的子系统</h1>
      <div class="home-content">
        <div class="admin-box" v-if="isAdmin" @click="toAdmin">
          <div class="nav-item nav-admin" >总管理员</div>
        </div>

        <div class="project-list ">
          <div class="project-item flex align-center justify-between" v-for="item in project" :key="item.item_id">
            <div class="project-item-title flex align-center justify-around">{{ item.item_name }}</div>
            <div class="flex align-center flex-sub flex-wrap">
              <div class="project-item-role flex align-center justify-around "
                   v-for="(son,index) in item.orgs"
                   :key="index"
                   @click="toDetail(item.item_id, son.org_id,son.org_type,son.xietiao)">
                <div>
                  <p>

                  </p>
                  <h3>
                    <span v-if="son.xietiao ===2" >培训协调中心</span>
                    <span v-else-if="son.xietiao ===3" >实习协调中心</span>
                    <span v-else-if="son.xietiao ===4" >考场协调中心</span>
                    <span v-else-if="son.xietiao ===5" >教学协调中心</span>
                    <span v-else>{{ son.org_type_name }}</span>
                    </h3>
                  <p class="ovHide2">{{ son.org_name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getChances, orgLogin} from "@/api/login";

export default {
  name: "home",
  data() {
    return {
      munes: [],
      chioseProject: 0
    };
  },
  computed: {
    isAdmin() {
      return this.munes.length > 0 && this.munes[0].item_id === 0;
    },
    project() {
      let arr = [];
      this.munes.map(item => {
        if (item.item_id !== 0) {
          arr.push(item);
        }
      });
      return arr;
    }
  },
  created() {
    window.localStorage.setItem('xietiao',0)
    this.getChances();
  },
  methods: {
    async getChances() {
      let _data = await getChances(this.$store.state.token1);
      this.munes = _data.data;
    },
    async toDetail(id, org_id,type,xietiao) {
      window.localStorage.setItem('xietiao',xietiao)
      let _data = await orgLogin(this.$store.state.token1, id, org_id,type);
      this.$store.state.token2 = _data.data.token
      if(_data.data.noperfect === 1){
        if(_data.data.org_type === 2) return this.$router.push('/train/info?noperfect=1')
        if(_data.data.org_type === 3) return this.$router.push('/practiceBase/info?noperfect=1')
        if(_data.data.org_type === 4) return this.$router.push('/examination/info?noperfect=1')
        if(_data.data.org_type === 5) return this.$router.push('/fuse/info?noperfect=1')
      }else if(_data.data.shen === 1){
        this.$confirm("该机构将于"+_data.data.due_date+"日到期，以防影响您的正常使用，请及时前往机构信息页提交机构材料。", "温馨提示", {
          confirmButtonText: "立即前往提交",
          cancelButtonText: "我知道了",
          cancelButtonClass: "msg-btn",
          confirmButtonClass: "msg-btn",
          center: true
        }).then(() => {
          if(_data.data.org_type === 2) return this.$router.push('/train/info')
          if(_data.data.org_type === 3) return this.$router.push('/practiceBase/info')
          if(_data.data.org_type === 4) return this.$router.push('/examination/info')
          if(_data.data.org_type === 5) return this.$router.push('/fuse/info')

        }).catch(()=>{
          this.$router.push(_data.data.menu)
        });
      }else{
        this.$router.push(_data.data.menu)
      }

    },
    async toAdmin() {
      let _data = await orgLogin(this.$store.state.token1, 0, 0,0);
      this.$store.state.token2 = _data.data.token
      this.$router.push(_data.data.menu)
    }
  }
};
</script>

<style scoped lang="scss">
.home-warpper {
  display: block;
  width: 100%;
  min-height: 100vh;
  background: url(../assets/img/loginbg.jpg) no-repeat;
  background-size: 100% 100%;

  .home-box {
    display: block;
    width: 1020px;
    margin: 0 auto;
    padding-top: 170px;

    h1 {
      font-size: 40px;
      line-height: 60px;
      margin-bottom: 40px;
      letter-spacing: 4px;
      color: #333333;
      text-align: center;
    }

    .home-content {
      width: 1020px;
      padding: 30px;
      background-color: #ffffff;
      box-shadow: 0px 8px 18px 0px rgba(231, 231, 231, 0.32);
      border-radius: 8px;

      .admin-box {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 90px;
        text-align: center;
        line-height: 90px;
        margin: 0 20px 20px 0;
        font-size: 22px;
        color: #fff;
        border-radius: 4px;
        background: #009688;
        cursor: pointer;

      }

      .project-list {

        .project-item {
          padding: 20px 0 0;
          border-top: 1px solid #eee;

          .project-item-title {
            width: 267px;
            height: 95px;
            padding: 10px;
            font-size: 20px;
            line-height: 30px;
            font-weight: bold;
            background-color: #eeeeee;
            border-radius: 4px;
            text-align: center;
            margin-right: 25px;
            margin-bottom: 20px;
          }

          .project-item-role {
            width: 208px;
            height: 95px;
            background-color: #009688;
            border-radius: 4px;
            margin-bottom: 20px;
            margin-right: 20px;
            cursor: pointer;

            &:nth-child(3n) {
              margin-right: 0;
            }

            div {
              width: 100%;
              color: #fff;
              padding: 0 20px;

              h3 {
                font-size: 16px;
                margin: 10px 0;
                text-align: center;
              }

              p {
                width: 100%;
                font-size: 16px;
                text-align: center;
              }
            }
          }
        }
      }


    }
  }
}
</style>
